import React from "react"
import { Doughnut } from "react-chartjs-2"
import Text from "../../../../../_components/Text"
import { getResumePayments  } from "../../../../../api/sales"
import * as colors from "../../../../../assets/_base/colors"

import SalesPerDays from "./SalesPerDays"


const payments = [
    {
        "id": "4bf2b774-3476-49fc-bb26-591e363a415d",
        "name": "Dinheiro",
        "bg": colors.success,
    },
    {
        "id": "2f903e2c-3f25-43aa-81e4-3a803f779a91",
        "name": "Cartão de Crédito",
        "bg": colors.danger
    },
    {
        "id": "30611e18-d7e9-455b-8c79-4874e45bd9e8",
        "name": "Cartão de Débito",
        "bg": colors.lightBlue
    },
    {
        "id": "66d2e0bb-cd7a-41b1-9422-f955b8aca0d2",
        "name": "Transferência Bancária",
        "bg": colors.yellow
    },
    {
        "id": "85b486e2-1cfb-4b09-ae36-6c53c93984a2",
        "name": "Boleto Bancário",
        "bg": colors.warn
    },
    {
        "id": "8c98684f-3dfd-4366-9611-849a37f36c51",
        "name": "Programa de fidelidade, Cashback, Crédito Virtual",
        "bg": colors.successVariant
    },
    {
        "id": "fdf93dcb-3352-439e-85b9-4fac221b9b92",
        "name": "PIX",
        "bg": colors.darkBlue
    }
]

const defaultMonthLabels = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"]

export default props => {
    const [paymentsData, setPaymentsData] = React.useState({})
    const [startDate, setStartDate] = React.useState('')
    const [endDate, setEndDate] = React.useState('')


    const ref = React.useRef(null)

    async function loadPaymentsChartData() {
        await getResumePayments().then(response => {
            let filteresPayments = []
            for (let pay of response) {
                filteresPayments.push({
                    id: pay.payment_method,
                    name: payments.filter(item => item.id === pay.payment_method)[0].name,
                    bg: payments.filter(item => item.id === pay.payment_method)[0].bg,
                    total: pay.total
                })
            }
            let names = [];
            let values = [];
            let bg = [];
            for (let x of filteresPayments) {
                names.push(x.name)
                values.push(x.total)
                bg.push(x.bg)
            }
            setPaymentsData({
                labels: names,
                datasets: [
                    {
                        label: "#",
                        data: values,
                        backgroundColor: bg
                    }
                ]
            })
        })
    }


    React.useEffect(() => {


        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        setStartDate(firstDayOfMonth.toISOString().split('T')[0]);
        setEndDate(today.toISOString().split('T')[0]);
        if (ref.current) {
            loadPaymentsChartData()
        }
    }, [ref.current])


    React.useEffect(() => {
        if (startDate && endDate) {
        }
    }, [startDate, endDate])

    return <div className="row" ref={ref}>
        <div className="col-12 my-3">
            <Text color="primary" fontSize="1.4em">
                Faturamento em gráficos
            </Text>
        </div>
        <div className="col-md-6 col-lg-6">
            <SalesPerDays />
        </div>
        <div className="col-md-6 col-lg-6">
            <Text as="h3">
                Formas de pagamentos
            </Text>
            <Doughnut data={paymentsData} />
        </div>

    </div>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Dashboard/components/Charts/index.jsx